import { isSuperLollipopActive } from 'src/replicant/superLollipop/superLollipop.getters';
import type { Component, Entity2D } from '../../odie';

import { CubeBlockProps } from '../defs/block';
import { CubeBlockView } from '../views/blocks/CubeBlockView';
import { user } from 'src/StateObserver';
import { SuperCubeBlockView } from '../views/blocks/SupeCubeBlockView';

// types
//-----------------------------------------------------------------------------
export type CubeBlockComponentOptions = {
  props: CubeBlockProps;
};

/*
    cube block component
*/
export class CubeBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCube';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: CubeBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: CubeBlockComponentOptions): void {
    // create cube block view
    if (isSuperLollipopActive(user())) {
      this.view = new SuperCubeBlockView(options.props);
    } else {
      this.view = new CubeBlockView(options.props);
    }
  }
}
